<app-core-popup
  [header]="'case-payment-receiver.popup-header' | translate"
  [dialogStyle]="{ width: '50vw' }"
  [saveText]="(paymentReceiverId ? 'common.update' : 'common.save') | translate"
  (chooseOn)="saveReceiver()"
  (closeOn)="onClose()"
  [showSecondButton]="paymentReceiverId ? true : false"
  [secondButtonText]="'common.remove' | translate"
  (secondButtonChooseOn)="deletePopup()"
  #formPopup
>
  <form [formGroup]="receiverForm" class="w-100">
    <!-- Toggle -->
    <div class="type-toggle mb-3">
      <input
        type="radio"
        id="mPerson"
        name="type"
        [checked]="type === 'PERSON'"
        (change)="setMode('PERSON')"
        class="pill"
      />
      <label for="mPerson" class="pill-label">{{
        "case-payment-receiver.person" | translate
      }}</label>

      <input
        type="radio"
        id="mCompany"
        name="type"
        [checked]="type === 'INSTITUTION'"
        (change)="setMode('INSTITUTION')"
        class="pill ms-3"
      />
      <label for="mCompany" class="pill-label"
        >{{ "case-payment-receiver.institution" | translate }}
      </label>
    </div>

    <!-- Kişi Modu -->
    <ng-container *ngIf="type === 'PERSON'">
      <div class="panel">
        <div class="panel__body">

          <div class="form-row">
            <div class="form-field half-width">
              <label for="personNo">{{
                "case-payment-receiver.patient-no" | translate
                }}</label>
              <app-patient-card (selectOn)="onPatientSelect($event)" [disabledInfoButton]="true"
                #patientCard></app-patient-card>
            </div>

            <div class="form-field half-width">
              <label class="required-star" for="fullName">{{
                "case-payment-receiver.fullname" | translate
                }}</label>
              <input id="fullName" type="text" formControlName="fullName" [class.is-invalid]="isInvalid('fullName')" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['fullName']?.value">
                {{ "validation.required" | translate }}
              </div>
            </div>
          </div>

          <div class="form-field">
            <label class="required-star" for="tckn">TCKN</label>
            <input id="tckn" type="text" formControlName="tckn" [class.is-invalid]="isInvalid('tckn')" />
            <div class="error" *ngIf="isSubmit && !receiverForm.controls['tckn']?.value">
              {{ "validation.required" | translate }}
            </div>
          </div>

          <div class="form-row">
            <div class="form-field half-width">
              <label class="required-star" for="phone">
                {{ "case-payment-receiver.phone" | translate }}
              </label>
              <input id="phone" type="tel" formControlName="phone" appPhoneMaskTR inputmode="numeric"
                placeholder="(5xx) xxx xx xx" [class.is-invalid]="isInvalid('phone')" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['phone']?.value">
                {{ "validation.required" | translate }}
              </div>
              <div class="error" *ngIf="
                  isSubmit &&
                  receiverForm.controls['phone']?.value &&
                  receiverForm.controls['phone']?.value?.length !== 10
                ">
                {{ "case-payment-receiver.phone-digit" | translate }}
              </div>
            </div>

            <div class="form-field half-width">
              <label class="required-star" for="email">{{
                "case-payment-receiver.email" | translate
                }}</label>
              <input id="email" type="email" formControlName="email" [class.is-invalid]="isInvalid('email')" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['email']?.value">
                {{ "validation.required" | translate }}
              </div>
            </div>
          </div>

          <div class="form-field">
            <label class="required-star" for="address">{{
              "case-payment-receiver.address" | translate
              }}</label>
            <textarea id="address" rows="2" formControlName="address" [class.is-invalid]="isInvalid('address')"></textarea>
            <div class="error" *ngIf="isSubmit && !receiverForm.controls['address']?.value">
              {{ "validation.required" | translate }}
            </div>
          </div>

          <div class="form-field">
            <label for="description">{{
              "case-payment-receiver.description" | translate
              }}</label>
            <textarea id="description" rows="2" formControlName="description" [maxlength]="255"></textarea>
          </div>

        </div>
      </div>
    </ng-container>

    <!-- Kurum Modu -->
    <ng-container *ngIf="type === 'INSTITUTION'">
      <div class="panel">
        <div class="panel__body">
          <div class="form-field">
            <label for="institutionNo">{{
              "case-payment-receiver.institution-no" | translate
              }}</label>
            <p-dropdown [options]="institutions" appendTo="body" [filter]="true" formControlName="institutionNo"
              [showClear]="true" [placeholder]="'case-payment-receiver.institution-no' | translate"></p-dropdown>
          </div>

          <div class="form-field">
            <label class="required-star" for="institutionName">{{
              "case-payment-receiver.institution-name" | translate
              }}</label>
            <input id="institutionName" type="text" formControlName="institutionName"
              [class.is-invalid]="isInvalid('institutionName')" />
            <div class="error" *ngIf="isSubmit && !receiverForm.controls['institutionName']?.value">
              {{ "validation.required" | translate }}
            </div>
          </div>

          <div class="form-row">
            <div class="form-field half-width">
              <label class="required-star" for="taxOffice">
                {{ "case-payment-receiver.tax-office" | translate }}
              </label>
              <input id="taxOffice" type="text" formControlName="taxOffice" [class.is-invalid]="isInvalid('taxOffice')" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['taxOffice']?.value">
                {{ "validation.required" | translate }}
              </div>
            </div>

            <div class="form-field half-width">
              <label class="required-star" for="taxNo">{{
                "case-payment-receiver.tax-no" | translate
                }}</label>
              <input id="taxNo" type="text" formControlName="taxNo" inputmode="numeric" maxlength="10" placeholder="10 hane"
                [class.is-invalid]="isInvalid('taxNo')" (keypress)="onlyDigit($event)" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['taxNo']?.value">
                {{ "validation.required" | translate }}
              </div>
              <div class="error" *ngIf="
                  isSubmit &&
                  receiverForm.controls['taxNo']?.value &&
                  receiverForm.controls['taxNo']?.value?.length !== 10
                ">
                {{ "case-payment-receiver.tax-no-digit" | translate }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field half-width">
              <label class="required-star" for="phone">
                {{ "case-payment-receiver.phone" | translate }}
              </label>
              <input type="tel" formControlName="phone" appPhoneMaskTR inputmode="numeric"
                placeholder="(5xx) xxx xx xx" [class.is-invalid]="isInvalid('phone')" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['phone']?.value">
                {{ "validation.required" | translate }}
              </div>
              <div class="error" *ngIf="
                  isSubmit &&
                  receiverForm.controls['phone']?.value &&
                  receiverForm.controls['phone']?.value?.length !== 10
                ">
                {{ "case-payment-receiver.phone-digit" | translate }}
              </div>
            </div>

            <div class="form-field half-width">
              <label class="required-star" for="email">
                {{ "case-payment-receiver.email" | translate }}
              </label>
              <input id="cEmail" type="email" formControlName="email" [class.is-invalid]="isInvalid('email')" />
              <div class="error" *ngIf="isSubmit && !receiverForm.controls['email']?.value">
                {{ "validation.required" | translate }}
              </div>
            </div>
          </div>

          <div class="form-field">
            <label class="required-star" for="address">
              {{ "case-payment-receiver.address" | translate }}
            </label>
            <textarea id="cAddress" rows="2" formControlName="address" [class.is-invalid]="isInvalid('address')"></textarea>
            <div class="error" *ngIf="isSubmit && !receiverForm.controls['address']?.value">
              {{ "validation.required" | translate }}
            </div>
          </div>

          <div class="form-field">
            <label for="description">{{
              "case-payment-receiver.description" | translate
              }}</label>
            <textarea id="cNote" rows="2" formControlName="description" [maxlength]="255"></textarea>
          </div>
          <div class="form-field">
            <p-checkbox
              formControlName="saveInstitution"
              binary="true"
              label="Kurumu Kaydet"
            ></p-checkbox>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</app-core-popup>

<app-loading [loading]="loading" [fullScreen]="true"></app-loading>
<app-save-intituation-popup
  #instCreatePopup
  (saved)="onNewInstituationSaved($event)"
></app-save-intituation-popup>